















































import Vue from 'vue';
import ApiSearchPage from '@/components/apiSearch/components/ApiSearchPage.vue';
import { ColumnType } from '@/components/apiSearch/models/ApiSearch';
import IconButton from "@/components/IconButton.vue";
import DownloadableInvoiceItemsView from "./DownloadableInvoiceItemsView.vue";
import http, { handleApiResponse } from '@/services/http';
import ApiResponse from '@/models/ApiResponse';
import eventBus from '@/services/eventBus';
import { t } from "@/plugins/i18n";

export default {
  components: {
    ApiSearchPage,
    IconButton,
    DownloadableInvoiceItemsView
  },

  methods: {
    showDetails(i: any) {
      i.selected = !i.selected;
    },

    async download(i: number) {
      console.log(i);
      const ret = await http.post<ApiResponse<boolean>>(`downloadable-invoices/download/${i}`).then(handleApiResponse);
      if (ret) {
        eventBus.$emit("success", t("DownloadInvoices_SikeresBetoltes"))
      }
      else {
        eventBus.$emit("error", t("DownloadInvoices_SikertelenBetoltes"))
      }
    }
  },

  computed: {
    columns: () => [
      {
        cell: "selectButton",
        filterable: false,
      },
      {
        field: "id",
        title: t("Azonosito"),
      },
      {
        field: "prefix",
        title: t("Prefix"),
        width: "100"
      },
      {
        field: "invNo",
        title: t("Szamlaszam"),
      },
      {
        field: "sellerName",
        title: t("PartnerNev"),
      },
      {
        field: "buyerName",
        title: t("DownloadInvoices_VevoNev"),
      },
      // {
      //   field: "status",
      //   title: "Státusz",
      // },
      {
        field: "invTypeName",
        title: t("SzamlaTipus"),
      },
      {
        field: "payMode",
        title: t("FizetesiMod"),
      },
      {
        field: "netto",
        title: t("Netto"),
        type: ColumnType.Money,
        filterable: false
      },
      {
        field: "vat",
        title: t("AFA"),
        type: ColumnType.Money,
        filterable: false
      },
      {
        field: "brutto",
        title: t("Brutto"),
        type: ColumnType.Money,
        filterable: false
      },
      {
        field: "currency",
        title: t("Penznem"),
      },
      {
        field: "k2dId",
        title: "K2D ID",
      },
      // {
      //   filterable: false,
      //   cell: "downloadTemplate"
      // },
    ]
  },
}
